import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-magic-uses-purification',
  templateUrl: './magic-uses-purification.component.html',
  styleUrls: ['./magic-uses-purification.component.css']
})
export class MagicUsesPurificationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
